import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { RiskFactorComponentView } from '../RiskFactorComponentView';

/**
 * リスクファクター画面（placeholder）情報
 */
export class RiskFactorPHMode extends WprBaseViewModeInfo<RiskFactorComponentView>{
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('riskFactorPHMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('OTA');
		list.push('DTP');
	}

	/**
	 * フィールド定義を登録
	 */
	public onRegisterControl(): void{
		this.addControl('periodFrom', { placeholder: [{ mode: 'OTA', value: '自宅を出発する日（日本時間）'}, { mode: 'DTP', value: '自宅を出発する日'}],},);
		this.addControl('periodTo', { placeholder: [{ mode: 'OTA', value: '自宅に戻る日（日本時間）'}, { mode: 'DTP', value: '自宅に戻る日'}],},);
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		return this.getGlobalMode('product');
	}
	// --------------------------------------------------------------------------
}